module.exports = __webpack_public_path__ + "media/images/icon03-2c968a3f173e8408abc5b11f54788065.png";